import type { TrackModel } from "../../models/models";
import { AUDIO_TYPE, COLLECTION_IDS } from "../../models/dictionary";

export const cafeTracks: TrackModel[] = [
	{
		id: "aa885b1f-42bf-4e72-b120-60386cefad02",
		audioUrlStub: "https://audios.coffitivity.com/morning-murmur",
		slug: "morning-murmur",
		name: "Morning Murmur",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		description: "A gentle hum gets the day going.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/morning-murmur",
		albumId: "d12f547c-6a2d-4789-bd3d-e74a37f5b6fe",
		location: {
			name: "Shockoe Espresso",
			address1: "104 Shockoe Slip",
			address2: null,
			cityOrLocality: "Richmond",
			stateOrProvince: "Virginia",
			country: "United States",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2013-03-03 11:29:54+00",
	},
	{
		id: "28226607-f0ea-4d24-b1cf-afaf42de8554",
		audioUrlStub: "https://audios.coffitivity.com/lunchtime-lounge",
		slug: "lunchtime-lounge",
		name: "Lunchtime Lounge",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		description: "Bustling chatter of the lunchtime rush.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/lunchtime-lounge",
		albumId: "d12f547c-6a2d-4789-bd3d-e74a37f5b6fe",
		location: {
			name: "Harrison Street Café",
			address1: "402 N Harrison St",
			address2: null,
			cityOrLocality: "Richmond",
			stateOrProvince: "Virginia",
			country: "United States",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2013-03-03 11:29:55+00",
	},
	{
		id: "44dd90dd-c4ac-462e-80db-5fee51a61f67",
		audioUrlStub: "https://audios.coffitivity.com/university-undertones",
		slug: "university-undertones",
		name: "University Undertones",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		description: "The scholarly sounds of a university cafe.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/university-undertones",
		albumId: "d12f547c-6a2d-4789-bd3d-e74a37f5b6fe",
		location: {
			name: "Virginia Commonwealth University",
			address1: "901 Park Ave",
			address2: null,
			cityOrLocality: "Richmond",
			stateOrProvince: "Virginia",
			country: "United States",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2013-03-03 11:29:56+00",
	},
	{
		id: "fb624356-91c1-455e-817c-b6d856f787f0",
		audioUrlStub: "https://audios.coffitivity.com/paris-paradise",
		slug: "paris-paradise",
		name: "Paris Paradise",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description: "Energizing ambiance from The City of Light.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/paris-paradise",
		albumId: "d12f547c-6a2d-4789-bd3d-e74a37f5b6fe",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "Paris",
			stateOrProvince: "Île-de-France",
			country: "France",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2013-03-03 11:29:57+00",
	},
	{
		id: "9c9ccb8c-3370-4ecc-8076-28f9ea2468f4",
		audioUrlStub: "https://audios.coffitivity.com/brazil-bistro",
		slug: "brazil-bistro",
		name: "Brazil Bistro",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description: "The musical chatter of a Brazilian coffeehouse.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/brazil-bistro",
		albumId: "d12f547c-6a2d-4789-bd3d-e74a37f5b6fe",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "São Paulo",
			stateOrProvince: "São Paulo",
			country: "Brazil",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2013-03-03 11:29:58+00",
	},
	{
		id: "b96b544e-fe1f-4ae2-8051-4d398a5c194c",
		audioUrlStub: "https://audios.coffitivity.com/texas-teahouse",
		slug: "texas-teahouse",
		name: "Texas Teahouse",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description: "Hefty sounds from a big state.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/texas-teahouse",
		albumId: "d12f547c-6a2d-4789-bd3d-e74a37f5b6fe",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: null,
			stateOrProvince: "Texas",
			country: "United States",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2013-03-03 11:29:59+00",
	},
	{
		id: "075c08ea-7b7c-4a3c-8898-7b5c78ef77ec",
		audioUrlStub: "https://audios.coffitivity.com/bogota-buzz",
		slug: "bogota-buzz",
		name: "Bogotá Buzz",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"Feel the vibrant hum of a Colombian café, where the world's finest coffee fuels deep conversation and city life.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/bogota-buzz",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "Bogotá",
			stateOrProvince: "",
			country: "Columbia",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "e0794e05-644b-4e18-96fd-d92741467d0b",
		audioUrlStub: "https://audios.coffitivity.com/columbian-coffeehouse",
		slug: "columbian-coffeehouse",
		name: "Colombian Coffeehouse",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"A taste of London with a global twist—where the aroma of Colombian beans meets the charm of a cozy UK café.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/columbian-coffeehouse",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "London",
			stateOrProvince: "",
			country: "England",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "0d25d550-57b1-4cfa-9865-55dd2f84ccf2",
		audioUrlStub: "https://audios.coffitivity.com/the-london-roast",
		slug: "the-london-roast",
		name: "The London Roast",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"A classic British café ambiance—warm, bustling, and brewing with the perfect mix of espresso and chatter.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/the-london-roast",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "London",
			stateOrProvince: "",
			country: "England",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "d3038d12-11ca-408e-b61e-0f61ebd0196b",
		audioUrlStub: "https://audios.coffitivity.com/kaffetid",
		slug: "kaffetid",
		name: "Kaffetid",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"Its coffee time, Swedish-style — a cozy café corner where fika, friends, and fresh brews keep the world turning.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/kaffetid",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "Stockholm",
			stateOrProvince: "",
			country: "Sweden",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "608a60c5-df8f-4893-8c20-13cec794529a",
		audioUrlStub: "https://audios.coffitivity.com/nordic-nook",
		slug: "nordic-nook",
		name: "Nordic Nook",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"A warm Scandinavian retreat, where minimalist charm meets the soothing sounds of a Stockholm café.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/nordic-nook",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "Stockholm",
			stateOrProvince: "",
			country: "Sweden",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "b3c3ff99-00b3-45df-9d91-2a53b2edf2d5",
		audioUrlStub: "https://audios.coffitivity.com/pastelaria-pulse",
		slug: "pastelaria-pulse",
		name: "Pastelaria Pulse",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"The gentle buzz of a Portuguese café, where the espresso is rich, the pastries are sweet, and the world moves at just the right pace.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/pastelaria-pulse",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "Oeiras",
			stateOrProvince: "",
			country: "Portugal",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "179753da-7d3b-4fcb-8f08-d48e45dc3787",
		audioUrlStub: "https://audios.coffitivity.com/porto-pour",
		slug: "porto-pour",
		name: "Porto Pour",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"Sink into the laid-back rhythm of a café along the Douro River, where the coffee is strong and the streets are alive.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/porto-pour",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "Oeiras",
			stateOrProvince: "",
			country: "Portugal",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "1cca9cde-7cbd-480f-a3e5-85a620030187",
		audioUrlStub: "https://audios.coffitivity.com/plaza-perk",
		slug: "plaza-perk",
		name: "Plaza Perk",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"Grab a seat in a lively Argentinian plaza, where clinking cups, laughter, and espresso shots fuel the day.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/plaza-perk",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "",
			stateOrProvince: "",
			country: "Argentina",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-06 11:29:59+00",
	},
	{
		id: "037fc865-2ebb-4ccc-80cc-ebd983235894",
		audioUrlStub: "https://audios.coffitivity.com/taipei-tones",
		slug: "taipei-tones",
		name: "Taipei Tones",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"Evokes the everyday rhythm of the city—lively, nuanced, and quietly energizing.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/taipei-tones",
		albumId: "26c81cb6-b1b7-43af-84ac-995fdbfd2d86",
		location: {
			name: null,
			address1: null,
			address2: null,
			cityOrLocality: "Taipei",
			stateOrProvince: "",
			country: "Taiwan",
		},
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:stimulation", "effects:creativity", "effects:focus"],
		blend: null,
		userId: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-04-30 11:29:59+00",
	},
	{
		id: "abe806bf-3049-4093-8e0c-789650bba16d",
		type: AUDIO_TYPE.TRACK,
		name: "Florence In Bloom",
		slug: "florence-in-bloom",
		description:
			"Enjoy the open-air atrium in the heart of Florence, Italy, at the café attached to the historic Oblate Library. You'll be accompanied by soft conversation, the laughter of children, and the songs of nearby birds.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		createdAt: "2025-08-01 20:47:35.29594+00",
		updatedAt: "2025-08-01 20:47:35.29594+00",
		releaseDate: "2025-08-01 10:00:00+00",
		blend: null,
		imageUrlStub: "https://images.coffitivity.com/florence-in-bloom",
		audioUrlStub: "https://audios.coffitivity.com/florence-in-bloom",
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		albumId: "194205c6-9587-48dc-8566-deb5c24cb5e3",
	},
	{
		id: "97db5abf-e8f7-4e64-8029-53d4476b268e",
		type: AUDIO_TYPE.TRACK,
		name: "Under the Red Arches",
		slug: "under-the-red-arches",
		description:
			"Seated outside a café nestled beneath the red arches of Bologna, Italy, you'll hear the ebb and flow of the crowd as bicycles and cars pass along the nearby cobblestone streets.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		createdAt: "2025-08-01 20:47:35.29594+00",
		updatedAt: "2025-08-01 20:47:35.29594+00",
		releaseDate: "2025-08-01 10:00:00+00",
		blend: null,
		imageUrlStub: "https://images.coffitivity.com/under-the-red-arches",
		audioUrlStub: "https://audios.coffitivity.com/under-the-red-arches",
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		albumId: "194205c6-9587-48dc-8566-deb5c24cb5e3",
	},
	{
		id: "752fd074-aa74-45ea-922a-231a258e769a",
		type: AUDIO_TYPE.TRACK,
		name: "Notes of Napoli",
		slug: "notes-of-napoli",
		description:
			"Soak in the spirited atmosphere of a bustling Neapolitan café. This lively recording captures the sounds of animated conversation, clinking cups, and the distant hum of cars and Vespas weaving through the streets of Naples. It's a true taste of southern Italian life: vibrant, bold, and full of energy.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		createdAt: "2025-08-01 20:47:35.29594+00",
		updatedAt: "2025-08-01 20:47:35.29594+00",
		releaseDate: "2025-08-01 10:00:00+00",
		blend: null,
		imageUrlStub: "https://images.coffitivity.com/notes-of-napoli",
		audioUrlStub: "https://audios.coffitivity.com/notes-of-napoli",
		collectionId: COLLECTION_IDS.CAFE,
		effectIds: ["effects:creativity", "effects:stimulation", "effects:focus"],
		albumId: "194205c6-9587-48dc-8566-deb5c24cb5e3",
	},
];
